import { IServiceInterface } from "@/interfaces/service-interface.interface";
import { ServiceInterfaceMessages } from "@/messages/service-interface/service-interface.messages";
import { FilterType, IFilter } from "@/types/filter.types";

export const SERVICE_INTERFACE_TABLE_COLUMNS = (messages: ServiceInterfaceMessages) => [
  messages.platformColumn,
  messages.descriptionColumn,
  messages.isActiveColumn,
  messages.intervalInSecondsColumn,
  messages.lastExecutionColumn,
  messages.isRunningColumn,
  messages.isPausedColumn,
  messages.countErrorsColumn,
  messages.countSuccessColumn,
  messages.optionsColumn,
];

export const initialFilterValues: IFilter<IServiceInterface>[] = [];
